import React from 'react'
import '../assets/styles/Home.css'
import accueil_logo_palisep from '../assets/images/accueil/accueil_logo-palisep.webp'
import mobile_accueil_logo_palisep from '../assets/images/accueil/mobile_accueil_logo-palisep.webp'
import accueil_armorial from '../assets/images/accueil/accueil_armorial.webp'
import mobile_accueil_armorial from '../assets/images/accueil/mobile_accueil_armorial.webp'
import accueil_livre from '../assets/images/accueil/accueil_livre.webp'
import mobile_accueil_livre from '../assets/images/accueil/mobile_accueil_livre.webp'
import accueil_armes2 from '../assets/images/accueil/accueil_armes2.webp'
import mobile_accueil_armes2 from '../assets/images/accueil/mobile_accueil_armes2.webp'
import accueil_bibli2 from '../assets/images/accueil/accueil_bibli2.webp'
import mobile_accueil_bibli2 from '../assets/images/accueil/mobile_accueil_bibli2.webp'
import accueil_logo_aibl from '../assets/images/accueil/accueil_logo-aibl.webp'
import mobile_accueil_logo_aibl from '../assets/images/accueil/mobile_accueil_logo-aibl.webp'
import accueil_logo_isep from '../assets/images/accueil/accueil_logo-isep.webp'
import mobile_accueil_logo_isep from '../assets/images/accueil/mobile_accueil_logo-isep.webp'
import { Link } from 'react-router-dom'

export default function Home() {

  return (
    <div id='home-container'>

      <div id='home-middle'>
        <Link to="/accueil">
          <img src={accueil_logo_palisep} srcSet={`${mobile_accueil_logo_palisep} 1x, ${accueil_logo_palisep} 2x`} alt="accueil_logo-palisep" />
        </Link>    
            
        <a href="https://heraldica.palisep.fr/">
          <p>Cours d'héraldique</p>
        </a>        
      </div>

      <div className='home-back-img'>
        <img src={accueil_armorial} srcSet={`${mobile_accueil_armorial} 1080w, ${accueil_armorial} 5203w`} sizes="50vw" alt="accueil_armorial" />
        <Link to="/armorial">
          <div className='home-back-text'>          
            L'armorial historique et monumental européen publie les campagnes d'inventaire photographique héraldique réalisées grâce à des missions commandées par les collectivités territoriales et la DRAC de l'ex-région Champagne Ardenne ainsi que des relevés dans d'autres régions ou pays (env. 5000 entrées).			
          </div>
        </Link>        
      </div>

      <div className='home-back-img'>
        <img src={accueil_livre} srcSet={`${mobile_accueil_livre} 1080w, ${accueil_livre} 3415w`} sizes="50vw" alt="accueil_livre" />
        <Link to="/livre">
          <div className='home-back-text'>            
				    L'héraldique et le livre publie des notices sur les fers de reliure et les présences héraldiques ou emblématiques sur ou dans le livre manuscrit ou imprimé (env. 1300 notices).
          </div>
        </Link>        
      </div>

      <div className='home-back-img'>
        <img src={accueil_armes2} srcSet={`${mobile_accueil_armes2} 1080w, ${accueil_armes2} 3415w`} sizes="50vw" alt="accueil_armes2" />
        <Link to="/heraldique">
          <div className='home-back-text'>  
            L'héraldique recense des armoiries européennes sous forme de blasonnements, fruit de dépouillements multiples (env. 350 000 entrées).			 
          </div>
        </Link>        
      </div>

      <div className='home-back-img'>
        <img src={accueil_bibli2} srcSet={`${mobile_accueil_bibli2} 1080w, ${accueil_bibli2} 3415w`} sizes="50vw" alt="accueil_bibli2" />
        <Link to="/bibliotheques">
          <div className='home-back-text'>
            La Bibliographie permet avec un lien d'accéder aux versions numérisées et mises en ligne d'une documentation manuscrite ou imprimée emblématiques et héraldiques par des organismes internationaux (Archives, bibliothèques, etc…).			
          </div>
        </Link>        
      </div>

      <div id='home-footer'>
        <a href="http://www.aibl.fr">
          <img id='home-footer-img-aibl' src={accueil_logo_aibl} srcSet={`${mobile_accueil_logo_aibl} 1x, ${accueil_logo_aibl} 2x`} alt="accueil_logo-aibl" />
        </a>
        
        <a href="http://isep.fr">
          <img id='home-footer-img-isep' src={accueil_logo_isep} srcSet={`${mobile_accueil_logo_isep} 1x, ${accueil_logo_isep} 2x`} alt="accueil_logo-isep" /> 
        </a>
      </div>
    </div>
  )
}
